import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
// import { ApiService } from '../../../services/api.service';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ActivatedRoute } from '@angular/router';
// import { environment } from '../../../../environments/environment';
import { EditorComponent } from '@tinymce/tinymce-angular';
// import { init } from '../../editorconfig';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { init } from '../editorconfig';
import { ApiService } from '../../services/api.service';

import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

interface User {
  id: number;
  name: string;
  email: string;
  department: string;
}

@Component({
  selector: 'app-seek-proposal',
  standalone: false,
  templateUrl: './seek-proposal.component.html',
  styleUrl: './seek-proposal.component.scss'
})
export class SeekProposalComponent {
  @ViewChild('fileUpload') fileUpload!: FileUpload;
    @Input() id: any
    @Input() getUrl: string;
    @Input() postUrl: string;
    @Input() base_url = environment.APIUrl;
    @Output() stepCompleted = new EventEmitter<void>();
    commentForm: FormGroup;
    @Input() step: any;
    @Output() IRA: EventEmitter<any> = new EventEmitter();
    @Input() isEditable: boolean = false;
    @Input() stepDetails: any;
    isEditorDisabled:boolean=false;
     init: EditorComponent['init'] = init;
    uploadedFiles: File[] = [];
    @Input() getPraposalurl: string;
    @Input() schemeType: any;
    payload: {
      proposal_id: any;
      // proposal_step:proposalStep,
      proposal_name: any;
    };
    qaAgencyData: any;
   @Output() generatePDFEmitter = new EventEmitter<any>();
    private subscriptions = new Subscription();
    userID: any;
  
  
    constructor(private fb: FormBuilder, private config: PrimeNGConfig, private messageService: MessageService, private api: ApiService, private route: ActivatedRoute) {
      this.commentForm = this.fb.group({
        comment: ['', Validators.required]
      });
      
      // Initialize user form
      this.userForm = this.fb.group({
        startDate: ['', Validators.required],
        endDate: ['', Validators.required],
        selectedUser: ['', Validators.required],
        remarks: ['', [Validators.required, Validators.minLength(10)]]
      });
      
      const role = sessionStorage.getItem('user_role_id');
      this.userID = role
    }
  
    ngOnInit(): void {
      this.route.queryParams.subscribe((params: any) => {
        const proposalId = params['id'];
        // const proposalStep = params['step'];
        const proposalName = params['name'];
        this.payload = {
          proposal_id: proposalId,
          // proposal_step:proposalStep,
          proposal_name: proposalName
        }
      });
      // this.api.getAPI(this.getUrl+this.id).subscribe((res:any)=>{
      //   this.qaAgencyData=res[0];
      //   this.patchFormValues(res.nomination_data[0]);
      //   if(res.nomination_data[0]?.status){
      //     this.commentForm.disable();
      //   }
      // })
     const sub = this.api.getAPI(this.getUrl + this.id + '&proposal_step__proposal=' + this.payload.proposal_id).subscribe((res: any) => {
        this.qaAgencyData = res;
        //console.log(this.qaAgencyData)
        this.patchFormValues(res.nomination_data[0]);
        this.commentForm.disable()
        if (res.nomination_data[0]?.status) {
          // this.commentForm.disable();
        }
      })
       this.subscriptions.add(sub);
    // if (this.isEditable) {
    //   this.commentForm.enable();
    // } else {
    //   this.commentForm.disable();
    // }
    }
      ngOnDestroy() {
      this.subscriptions.unsubscribe();
    }
    ngAfterViewInit(){
      setTimeout(() => {
         if (this.isEditable) {
          this.isEditorDisabled = false;
           this.commentForm.enable();
        } else {
          this.isEditorDisabled = true;
          this.commentForm.disable();
        }
        this.rebuildEditor()
      }, 3000);
    }
        editorReady = false;
    rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled
    };
  }
            goToNextStep(){
       this.stepCompleted.emit();
    }
    patchFormValues(data: any) {
      if (!data) return;
      //console.log(data);
      this.commentForm.patchValue({
        comment: data.paragraph
      });
    }
  
    editForm() {
      this.commentForm.enable();
      this.messageService.add({ severity: 'info', summary: 'info', detail: 'Form is now editable.' });
    }
  
  
    onUpload(event: any) {
      const formData = new FormData();
  
      for (let file of event.files) {
        this.uploadedFiles.push(file);
        formData.append('uploaded_file', file); // use array key if backend supports multiple
      }
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'File Attached successfully' });
  
    }
  
    onSubmitttt() {
      //console.log(this.commentForm.value);
      const formData = new FormData();
      formData.append('paragraph', this.commentForm.get('comment')?.value);
      formData.append('proposal_step', this.id);
  
      this.uploadedFiles.forEach(data => {
        formData.append('uploaded_file', data);
      })
      if (this.qaAgencyData?.nomination_data[0]?.id) {
      const sub =  this.api.putAPI(`${this.postUrl}${this.qaAgencyData?.nomination_data[0]?.id}/`, formData).subscribe((res: any) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Comment updated' });
          // this.fileUpload.clear();
          // this.stepCompleted.emit(); 
        })
         this.subscriptions.add(sub);
      } else {
       const sub = this.api.postAPI(`${this.postUrl}`, formData).subscribe((res: any) => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Comment submitted' });
          // this.fileUpload.clear();
          // this.stepCompleted.emit(); 
        })
         this.subscriptions.add(sub);
      }
    }
    getFileExtension(url: string) {
      return url.split('/').pop() || 'Unknown File';
    }
    generatePDF() {
      const payload = {
        url: '/revenue/need/version-control/',
        data: [
          { key: "Proposal Name", value: this.payload.proposal_name },
          { key: "Comments", value: this.commentForm.get('comment')?.value },
  
        ]
      };
      this.generatePDFEmitter.emit(payload);
    }
  //new code

    userForm: FormGroup;
  users: User[] = [
    { id: 1, name: 'John Doe', email: 'john.doe@company.com', department: 'Development' },
    { id: 2, name: 'Sarah Smith', email: 'sarah.smith@company.com', department: 'Marketing' },
    { id: 3, name: 'Mike Johnson', email: 'mike.johnson@company.com', department: 'Sales' },
    { id: 4, name: 'Emily Brown', email: 'emily.brown@company.com', department: 'HR' },
    { id: 5, name: 'David Wilson', email: 'david.wilson@company.com', department: 'Finance' }
  ];

  isLoading = false;
  isSubmitted = false;
  onSubmit(): void {
    this.isSubmitted = true;
    
    if (this.userForm.valid) {
      this.isLoading = true;
      
      const formData = {
        startDate: this.userForm.get('startDate')?.value,
        endDate: this.userForm.get('endDate')?.value,
        selectedUser: this.userForm.get('selectedUser')?.value,
        remarks: this.userForm.get('remarks')?.value
      };

      console.log('Form Data:', formData);
      
      // Simulate API call
      setTimeout(() => {
        this.isLoading = false;
        // Handle success/error here
        alert('Form submitted successfully!');
        this.resetForm();
      }, 2000);
    } else {
      this.markFormGroupTouched();
    }
  }

  resetForm(): void {
    this.userForm.reset();
    this.isSubmitted = false;
  }

  private markFormGroupTouched(): void {
    Object.keys(this.userForm.controls).forEach(key => {
      const control = this.userForm.get(key);
      control?.markAsTouched();
    });
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.userForm.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched || this.isSubmitted));
  }

  getFieldError(fieldName: string): string {
    const field = this.userForm.get(fieldName);
    if (field?.errors) {
      if (field.errors['required']) {
        return `${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is required`;
      }
      if (field.errors['minlength']) {
        return `${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} must be at least ${field.errors['minlength'].requiredLength} characters`;
      }
    }
    return '';
  }

  // Date validation
  onStartDateChange(event: any): void {
    const startDate = event.target.value;
    const endDateControl = this.userForm.get('endDate');
    
    if (endDateControl?.value && startDate > endDateControl.value) {
      endDateControl.setValue('');
    }
  }

  onEndDateChange(event: any): void {
    const endDate = event.target.value;
    const startDate = this.userForm.get('startDate')?.value;
    
    if (startDate && endDate < startDate) {
      this.userForm.get('endDate')?.setErrors({ 'invalidDate': true });
    }
  }

  // Helper methods for user data retrieval
  getSelectedUser(): User | undefined {
    const selectedUserId = this.userForm.get('selectedUser')?.value;
    return this.users.find(u => u.id == selectedUserId);
  }

  getSelectedUserName(): string {
    return this.getSelectedUser()?.name || '';
  }

  getSelectedUserEmail(): string {
    return this.getSelectedUser()?.email || '';
  }

  getSelectedUserDepartment(): string {
    return this.getSelectedUser()?.department || '';
  }

  getSelectedUserInitial(): string {
    const name = this.getSelectedUserName();
    return name ? name.charAt(0).toUpperCase() : '';
  }

}
